const installationSubcategories = [
  { key: 'Profesional', label: 'Profissional' },
  { key: 'Doméstico', label: 'Doméstico' },
  { key: 'Reinstalación', label: 'Reinstalação' },
  { key: 'Miele', label: 'Miele' }
]
const maintenanceSubcategories = [
  { key: 'Mantenimiento Regular', label: 'Manutenção regular' },
  { key: 'Certificado de servicio doméstico', label: 'Certificado de serviço doméstico' },
  { key: 'Certificado de mantenimiento Profesional', label: 'Certificado de manutenção profissional' },
  { key: 'Certificado de mantenimiento Doméstico', label: 'Certificado de manutenção doméstica' },
  { key: 'Miele', label: 'Miele' }
]

const repairSubcategories = [
  { key: 'Profesional', label: 'Profissional' },
  { key: 'Doméstico', label: 'Doméstico' },
  { key: 'Garantía de reparación previa - Profesional', label: 'Garantia de reparo prévio - Profissional' },
  { key: 'Garantía de reparación previa - Doméstico', label: 'Garantia de reparo prévio - Doméstico' },
  { key: 'Garantía de Manufactura', label: 'Garantia de fabricação' },
  { key: 'Garantía de instalación - Profesional', label: 'Garantia de instalação - Profissional' },
  { key: 'Garantía de instalación - Doméstico', label: 'Garantia de instalação - Doméstico' },
  { key: 'Cortesía - Cargo a ventas Profesional', label: 'Cortesia - Cobrança de vendas - Profissional' },
  { key: 'Cortesía - Cargo a ventas Doméstico', label: 'Cortesia - Cobrança de vendas - Doméstico' },
  { key: 'Cortesía - Cargo a Servicio', label: 'Cortesia - Cobrança de serviço' },
  { key: 'Diagnóstico', label: 'Diagnóstico' },
  { key: 'Miele', label: 'Miele' }
]

const fallbackSubcategories = [
  { key: 'Ninguna', label: 'Nenhuma' },
  { key: 'Miele', label: 'Miele' }
]

export { installationSubcategories, maintenanceSubcategories, repairSubcategories, fallbackSubcategories }
